import React from "react";
import Link from "./Link";
import useHover from "@react-hook/hover";
import ExpensesButton from "./ExpensesButton";
import SideSide from "../img/sideside.svg";
import expensePageLogo from "../img/ExpensePageLogo.png";
import optimizeLogo from "../img/OptimizeLogo.png";
import incomeLogo from "../img/IncomeLogo.png";
import homeLogo from "../img/HomeLogo.png";
import investLogo from '../img/InvestmentsPageLogo.png';
import OltreLogo from "../img/OltreLogo.png";
import rectangle5865 from "../img/rectangle-5865@2x.png";
import SettingsButton from "../components/SettingsButton";
import DashboardButtons from "./DashboardButtons";
import './Sidebar.css'

const Sidebar = (props) => {
    const { className } = props;


    return (
        <div>
            <div className="sidebar">
                <div className="group-1000005975">
                    <div className="flex-col-1">
                        <DashboardButtons />
                        <Link href='/revenue' className="rectangle-5866">
                            <img className="income-logo" src={incomeLogo} />
                            <div className={`income ${className || "nunito-bold-black-16px"}`}>Income</div>
                        </Link>
                        <Link href='/investments' className="rectangle-586">
                            <img className="group-1000005940" src={investLogo} />
                            <div className={`expenses ${className || "nunito-bold-black-16px"}`}>Investments</div>
                        </Link>
                        <Link href='/expenses' className="rectangle-586">
                            <img className="group-1000005962" src={expensePageLogo} />
                            <div className={`investments ${className || "nunito-bold-black-16px"}`}>Expenses</div>
                        </Link>
                        <Link href='/lifestrategy' className="rectangle-586">
                            <img className="group-1000005972" src={optimizeLogo} />
                            <div className={`optimize ${className || "nunito-bold-black-16px"}`}>Optimize</div>
                        </Link>
                        <img className="rectangle-5865" src={rectangle5865} />
                        <div className="rectangle-5863"></div>
                        <Link href='profile'>
                            <SettingsButton />
                        </Link>
                    </div>
                    <img className="rectangle-5224" src={SideSide} alt="sidebar sidebar" />
                </div>
            </div>
            <img className="group-1000006350" src={OltreLogo} alt="Oltre Logo" />
        </div>
    )
}

export default Sidebar;